import React, { FC } from "react";
import {
  Text,
  View,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  KeyboardAvoidingView,
} from "react-native";

import { Formik } from "formik";
import { AuthContext } from "../../contexts/auth/Store";
import * as Yup from "yup";

import { AnalyticsService } from "../../constants/Analytics";
import FormikInput from "../../components/form/FormikInput";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";
import http from "../../utils/http";
import GenericHeader from "../../components/headers/GenericHeader";
import { useNavigation } from "@react-navigation/native";
import { AlertBox } from "../../components/common/AlertBox";

const analytics = new AnalyticsService();

const RefCodeSchema = Yup.object().shape({
  refCode: Yup.string().min(4, "Enter a valid code").required("Enter a code"),
});

export const VoucherScreen: FC = () => {
  const navigation = useNavigation();
  const auth = React.useContext(AuthContext);
  const buyer = auth.getUserData.buyerData;
  const token = auth.getUserData.userToken;
  const [message, setMessage] = React.useState<any>({
    theme: '',
    body: ''
  })

  const submitCode = (code: any, actions: any) => {
    setMessage({})
    let form = new FormData();
    form.append("phone", code);
    form.append("referral", buyer.phone);
    form.append("status", "agency-unverified");
    http
      .post("agent_referral/create_phone", form, token)
      .then((res) => {
        actions.setSubmitting(false);
        if (res.code === 200) {
          analytics.logEvent("Submitted Referral Code", buyer, {
            agent_phone: code,
            referral: buyer.phone,
          });
          actions.resetForm();
          setMessage({theme: 'success', body: 'Reference code added successfully'})
        } else {
          setMessage({ theme: 'warning', body: res.message });
        }
      })
      .catch((err) => {
        actions.setSubmitting(false);
        setMessage({ theme: 'error', body: "An error occurred." });
        analytics.logError(err);
      });
  };

  return (
    <>
      <GenericHeader
        title={`Voucher`}
        backAction={() => navigation.navigate("Settings")}
      />
      <KeyboardAvoidingView keyboardVerticalOffset={30} behavior={"padding"}>
        <ScrollView
          style={styles.scrollView}
          contentContainerStyle={{ justifyContent: "flex-end" }}
        >
          {message?.body && message?.theme && (
            <View style={styles.alertContainer}>
              <AlertBox
                theme={message.theme}
                body={message.body}
                hideBox={(arg) => setMessage({})}
              />
            </View>
          )}
          
          {buyer && (
            <Formik
              initialValues={{
                refCode: "",
              }}
              validationSchema={RefCodeSchema}
              onSubmit={(values, actions) => {
                actions.setSubmitting(true);
                submitCode(values.refCode, actions);
              }}
            >
              {({ handleSubmit, isSubmitting, isValid }) => (
                <View>
                  {/* form goes here */}
                  <FormikInput
                    label="Reference code"
                    icon={{ name: "md-pricetag", style: {} }}
                    fieldName="refCode"
                  />

                  <TouchableOpacity
                    activeOpacity={isSubmitting ? 0.6 : 1}
                    style={[
                      styles.addCodeButton,
                      { opacity: isSubmitting || !isValid ? 0.6 : 1 },
                    ]}
                    onPress={() => handleSubmit()}
                    disabled={isSubmitting || !isValid}
                  >
                    {isSubmitting ? (
                      <ActivityIndicator
                        color="#FFF"
                        style={styles.loginText}
                      ></ActivityIndicator>
                    ) : (
                      <Text style={styles.loginText}>Add Reference Code</Text>
                    )}
                  </TouchableOpacity>
                </View>
              )}
            </Formik>
          )}
          {!buyer && (
            <View style={{ paddingTop: 42 }}>
              <ActivityIndicator size={48} color="#3B54EC" />
            </View>
          )}
        </ScrollView>
      </KeyboardAvoidingView>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
  },
  scrollView: {
    flexGrow: 1,
    height: "100%",
    backgroundColor: Colors.whiteColor,
    paddingHorizontal: 16,
    paddingBottom: 25,
  },
  addCodeButton: {
    height: 42,
    width: "100%",
    borderRadius: 4,
    backgroundColor: "#3B54EC",
    marginTop: 30,
    alignSelf: "center",
    marginBottom: 63,
  },
  loginText: {
    color: Colors.whiteColor,
    ...FontStyles.size14,
    ...FontStyles.lh16,
    ...FontStyles.medium,
    textAlign: "center",
    paddingHorizontal: 34,
    paddingVertical: 13,
    alignSelf: "center",
  },
  alertContainer: {
    paddingTop: 16
  }
});
